import React from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { project_types } from '../data/projects-types';

const programColors = {
    womens_empowerment: { bg: '#E8F5E9', border: '#2E7D32', icon: '👩‍🌾' },
    water_sanitation: { bg: '#E3F2FD', border: '#1565C0', icon: '💧' },
    sustainable_agriculture: { bg: '#FFF3E0', border: '#E65100', icon: '🌾' },
    environment_sustainability: { bg: '#F1F8E9', border: '#33691E', icon: '🌿' },
};

const cardVariants = {
    offscreen: { opacity: 0, y: 50 },
    onscreen: {
        opacity: 1,
        y: 0,
        transition: { type: "spring", bounce: 0.3, duration: 0.8 }
    }
};

const Projects = ({ darkMode }) => {
    const cardStyle = {
        color: darkMode ? '#f8f9fa' : '#212529',
        border: darkMode ? '1px solid #495057' : '1px solid #dee2e6',
        boxShadow: darkMode ? '0px 4px 6px rgba(0, 0, 0, 0.5)' : '0px 4px 6px rgba(0, 0, 0, 0.1)'
    };

    return (
        <Container style={{ minHeight: '100vh', paddingTop: '30px', paddingBottom: '30px' }}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className="text-center mb-3" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                    Our Programs
                </h2>
                <p className="text-center mb-5" style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.1rem' }}>
                    Guided by four thematic pillars — women's empowerment, water conservation and sanitation,
                    sustainable agriculture, and environmental sustainability — PSGS continues to deliver impactful,
                    community-driven solutions that foster resilience and long-term well-being.
                </p>
            </motion.div>

            <Row>
                {project_types.map((project, index) => {
                    const colors = programColors[project.value] || { bg: '#E8F5E9', border: '#2E7D32', icon: '🌍' };
                    return (
                        <Col md={6} key={project.id} className="mb-4">
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.3 }}
                                variants={cardVariants}
                                style={{ height: '100%' }}
                            >
                                <Card
                                    style={{
                                        ...cardStyle,
                                        backgroundColor: darkMode ? '#343a40' : colors.bg,
                                        borderLeft: `4px solid ${colors.border}`,
                                    }}
                                    className="h-100"
                                >
                                    <Card.Body className="d-flex flex-column justify-content-between">
                                        <div>
                                            <h1 className="mb-3">{colors.icon}</h1>
                                            <Card.Title style={{ color: colors.border, fontSize: '1.4rem' }}>
                                                {project.label}
                                            </Card.Title>
                                        </div>
                                        <Link
                                            to={`/programs/${project.value}`}
                                            className="btn mt-3"
                                            style={{
                                                backgroundColor: colors.border,
                                                color: '#ffffff',
                                                border: 'none',
                                                alignSelf: 'flex-start'
                                            }}
                                        >
                                            View Projects
                                        </Link>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
};

export default Projects;
